module.exports = __webpack_public_path__ + "static/imac-ee0d92b3ac44028badbea1f98158fa15.png";